<script lang="ts">
import { computed, defineComponent } from "vue";
import keycloakStore from "@/businesslogic/stores/keycloakStore";

export default defineComponent({
  name: "AbgesicherterBereich",
  components: {},
  props: {
    benoetigteRollen: Array,
    isMaklerLink: Boolean,
  },
  setup(props) {
    const externeRollenOhneGeschaeftsfuehrer = ["STANDARDNUTZER", "NUTZER", "NUTZER_NEUGESCHAEFT", "GAST", "MITNUTZER"];

    const isMaklerLinkErlaubt = computed(() => {
      for (const rolle of externeRollenOhneGeschaeftsfuehrer) {
        if (props.benoetigteRollen?.includes(rolle) && props.isMaklerLink) {
          return true;
        }
      }
      return false;
    });
    return { keycloakStore, props, isMaklerLinkErlaubt };
  },
});
</script>

<template>
  <slot v-if="keycloakStore().hatEineRolle(benoetigteRollen) || isMaklerLinkErlaubt"></slot>
</template>
<style scoped></style>
